export default __webpack_public_path__ + "da6143a97b8ed2ae857bf220ce14593c.woff2";